var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "documentation philatelie" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _vm._t("titre"),
        _vm._v(" "),
        _c("section", { staticClass: "filters" }, [
          _c("div", { staticClass: "wrap-head-filters" }, [
            _c("ul", { staticClass: "filtre-taaf-rnn" }, [
              _c("li", [
                _c(
                  "a",
                  {
                    class: { active: !_vm.archives },
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.switchPage(false)
                      },
                    },
                  },
                  [_vm._t("catalogLabel")],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    class: { active: _vm.archives },
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.switchPage(true)
                      },
                    },
                  },
                  [_vm._t("archiveLabel")],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.archives
              ? _c(
                  "div",
                  { staticClass: "custom-select-year" },
                  [
                    _c("p", [_vm._v("De :")]),
                    _vm._v(" "),
                    _c("custom-select", {
                      attrs: { options: _vm.startListYear },
                      on: {
                        change: function ($event) {
                          return _vm.updateSelect("from")
                        },
                      },
                      model: {
                        value: _vm.startYear,
                        callback: function ($$v) {
                          _vm.startYear = $$v
                        },
                        expression: "startYear",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.archives
              ? _c(
                  "div",
                  { staticClass: "custom-select-year" },
                  [
                    _c("p", [_vm._v("à :")]),
                    _vm._v(" "),
                    _c("custom-select", {
                      attrs: { options: _vm.endListYear },
                      on: {
                        change: function ($event) {
                          return _vm.updateSelect()
                        },
                      },
                      model: {
                        value: _vm.endYear,
                        callback: function ($$v) {
                          _vm.endYear = $$v
                        },
                        expression: "endYear",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "loader-wrap" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navigation-wrapper" },
          [
            _vm.showPrev
              ? _c("i", {
                  staticClass: "icon-arrow-right prev",
                  on: {
                    click: function ($event) {
                      return _vm.previousPage()
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showNext
              ? _c("i", {
                  staticClass: "icon-arrow-right next",
                  on: {
                    click: function ($event) {
                      return _vm.nextPage()
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "transition-group",
              {
                staticClass: "list-wrap",
                attrs: { tag: "div", css: false },
                on: { "before-enter": _vm.beforeEnter, enter: _vm.enter },
              },
              _vm._l(_vm.result, function (item, index) {
                return _c(
                  "article",
                  {
                    key: "key_" + index,
                    staticClass: "one-stamp",
                    attrs: { "data-index": index },
                  },
                  [
                    _c("div", { staticClass: "stamp-wrap" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: item.imgUrlFull, "data-fancybox": "" },
                        },
                        [
                          _c("img", {
                            attrs: { src: item.imgUrlPreview, alt: "" },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "infos" }, [
                      _c("h3", {
                        staticClass: "titre vert",
                        domProps: { innerHTML: _vm._s(item.title) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "collection",
                        domProps: { innerHTML: _vm._s(item.collection) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "type-timbre",
                        domProps: { innerHTML: _vm._s(item.type) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "format",
                        domProps: { innerHTML: _vm._s(item.format) },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "valeur",
                        domProps: { innerHTML: _vm._s(item.valeur) },
                      }),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.result && _vm.result.length === 0
              ? _c(
                  "p",
                  { staticClass: "no-results" },
                  [_vm._t("no-results")],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.loading && _vm.showPagination
          ? _c("pagination", {
              attrs: {
                pagination: _vm.pagination,
                params: _vm.form,
                offset: 2,
              },
              on: { paginate: _vm.formSubmit },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }